// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-list-container {
  overflow: hidden;
  background-color: white;
  min-width: 1220px;
  height: calc(100% - 50px);
}
.user-list-container .body {
  height: 100%;
  display: block;
  color: #2b495e;
}
.user-list-container .body .panel-main-header {
  width: calc(100% - 1rem);
  display: inline-block;
  height: 2rem;
  padding: 0.5rem;
}
.user-list-container .body .panel-main-header .panel-main-header-left {
  width: 40%;
  float: left;
}
.user-list-container .body .panel-main-header .panel-main-header-left .user-list-filter {
  height: 2rem;
}
.user-list-container .body .panel-main-header .panel-main-header-right {
  float: right;
}
.user-list-container .body .panel-main-header .panel-main-header-right .user-list-controls {
  line-height: 2rem;
  /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/
}
.user-list-container .body .panel-main-header .panel-main-header-right .user-list-controls .mat-button-toggle-group {
  height: 2rem;
  margin-right: 20px;
  /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/
}
.user-list-container .body .panel-main-header .panel-main-header-right .user-list-controls .mat-button-toggle-group mat-button-toggle {
  min-width: 100px;
}
.user-list-container .body .dashboard_grid_item {
  margin-left: 0.5rem;
  height: calc(100% - 9rem);
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_header.header-sticky .header_row {
  width: calc(100% - 1rem);
  height: 2.86rem;
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_header.header-sticky .header_row .cell_row {
  padding: 5px 0;
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_header.header-sticky .header_row .cell_row .cell_header {
  background-color: #eceef3;
  font-weight: bolder;
  padding: 0;
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_header.header-sticky .header_row .cell_row .user_data.user_level_head {
  min-width: calc(10rem + 30px);
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_header.header-sticky .header_row #header_title_row {
  padding: 0.5rem 0 0.5rem 0.5rem;
  background-color: #eceef3;
  border-bottom: 1px solid #050505;
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_header.header-sticky .cell_row .user_data.filter_cell input {
  width: 98%;
  height: 90%;
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_header.header-sticky .cell_row .user_data.filter_cell.user_level_filter {
  min-width: calc(10rem + 30px);
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_content {
  overflow: auto;
  height: 100%;
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_content .user_row {
  min-height: 36px;
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_content .user_row .cell_row .user_data .value {
  padding-left: 0.5rem;
  line-height: 36px;
  padding: 0;
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_content .no-data-error {
  background: transparent;
  left: -1rem;
  opacity: 1 !important;
  padding: 2rem;
  display: flex;
  flex-flow: column;
  align-items: center;
  width: calc(100% - 4rem);
  height: calc(100% - 10rem);
  position: absolute;
}
.user-list-container .body .dashboard_grid_item .dashboard_grid_content .no-data-error h1,
.user-list-container .body .dashboard_grid_item .dashboard_grid_content .no-data-error h3 {
  text-align: center;
}

.user-levels-name {
  grid-area: "level";
}

.user-levels-actions {
  grid-area: "actions";
}

:host::ng-deep {
  /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/
}
:host::ng-deep .mat-button-toggle-label-content {
  line-height: 2rem !important;
}
:host::ng-deep .cell_row {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 25% 25% 25% 15% 80px;
}
:host::ng-deep .cell_row .action_button_container {
  align-items: center;
  display: flex;
  gap: 0.25rem;
  height: 2.75rem;
  justify-content: center;
}
:host::ng-deep .cell_row .action_button_container .action_button {
  align-items: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 0.25rem;
  display: flex;
  height: 2rem;
  justify-content: center;
  transition: filter 0.35s;
  width: 2rem;
  font-size: 14px;
}
:host::ng-deep .cell_row .action_button_container .action_button:hover {
  background: rgba(0, 0, 0, 0.1);
}
:host::ng-deep .cell_row .action_button_container .action_button.disabled {
  filter: grayscale(1) opacity(0.5);
  pointer-events: none;
}
:host::ng-deep .cell_row .user_data {
  max-height: 130px;
  overflow: auto;
}

.processing-fadein {
  animation: fadein 1s;
}

.processing-fadeout {
  animation: fadeout 0.5s;
  display: none !important;
}

.processing--spinner {
  -ms-grid-columns: auto 1fr;
  background: whitesmoke;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);
  display: grid;
  font-size: 1rem;
  grid-template-columns: auto 1fr;
  height: 30px;
  left: calc(50% - 100px);
  line-height: 1.8rem;
  padding: 20px;
  position: absolute;
  text-align: center;
  top: calc(50% - 100px);
  -webkit-user-select: none;
          user-select: none;
  min-width: 200px;
  z-index: 9999 !important;
}

.user-levels-container {
  display: grid;
  grid-template-columns: repeat(3, auto);
  width: -moz-fit-content;
  width: fit-content;
  gap: 5px;
}
.user-levels-container .pill {
  background-color: rgba(236, 238, 243, 0.35);
  border-radius: 13px;
  border: solid 1px rgba(43, 73, 94, 0.2);
  font-size: 0.8rem;
  line-height: 13px;
  padding: 5px 10px;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: space-between;
}
.user-levels-container .pill .left {
  display: flex;
  gap: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/model-structure/scenarios/scenario-table/scenario-table.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBAAA;AACF;AACE;EACE,YAAA;EACA,cAAA;EACA,cAAA;AACJ;AACI;EACE,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AACN;AACM;EACE,UAAA;EACA,WAAA;AACR;AAAQ;EACE,YAAA;AAEV;AACM;EACE,YAAA;AACR;AAAQ;EACE,iBAAA;EACA,4HAAA;EACA,4HAAA;AAEV;AADU;EACE,YAAA;EACA,kBAAA;EACA,4HAAA;AAGZ;AAFY;EACE,gBAAA;AAId;AAII;EACE,mBAAA;EACA,yBAAA;AAFN;AAMQ;EACE,wBAAA;EACA,eAAA;AAJV;AAMU;EACE,cAAA;AAJZ;AAMY;EACE,yBAAA;EACA,mBAAA;EACA,UAAA;AAJd;AAOY;EACE,6BAAA;AALd;AASU;EACE,+BAAA;EACA,yBAAA;EACA,gCAAA;AAPZ;AAYY;EACE,UAAA;EACA,WAAA;AAVd;AAaU;EACE,6BAAA;AAXZ;AAiBM;EACE,cAAA;EACA,YAAA;AAfR;AAgBQ;EACE,gBAAA;AAdV;AAiBc;EACE,oBAAA;EACA,iBAAA;EACA,UAAA;AAfhB;AAqBQ;EACE,uBAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,0BAAA;EACA,kBAAA;AAnBV;AAoBU;;EAEE,kBAAA;AAlBZ;;AA0BA;EACE,kBAAA;AAvBF;;AA0BA;EACE,oBAAA;AAvBF;;AA0BA;EACE,4HAAA;AAvBF;AAwBE;EACE,4BAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,sBAAA;EACA,2CAAA;AAvBJ;AAyBI;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;AAvBN;AAyBM;EACE,mBAAA;EACA,+BAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,eAAA;AAvBR;AAyBQ;EACE,8BAAA;AAvBV;AA0BQ;EACE,iCAAA;EACA,oBAAA;AAxBV;AA6BI;EAEE,iBAAA;EACA,cAAA;AA5BN;;AAkCA;EACE,oBAAA;AA/BF;;AAiCA;EACE,uBAAA;EACA,wBAAA;AA9BF;;AAiCA;EAEE,0BAAA;EACA,sBAAA;EACA,uEAAA;EAEA,aAAA;EACA,eAAA;EACA,+BAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,wBAAA;AA/BF;;AAmCA;EACE,aAAA;EACA,sCAAA;EACA,uBAAA;EAAA,kBAAA;EACA,QAAA;AAhCF;AAkCE;EACE,2CAAA;EACA,mBAAA;EACA,uCAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,8BAAA;AAhCJ;AAkCI;EACE,aAAA;EACA,QAAA;AAhCN","sourcesContent":[".user-list-container {\r\n  overflow: hidden;\r\n  background-color: white;\r\n  min-width: 1220px;\r\n  height: calc(100% - 50px);\r\n\r\n  .body {\r\n    height: 100%;\r\n    display: block;\r\n    color: #2b495e;\r\n\r\n    .panel-main-header {\r\n      width: calc(100% - 1rem);\r\n      display: inline-block;\r\n      height: 2rem;\r\n      padding: 0.5rem;\r\n\r\n      .panel-main-header-left {\r\n        width: 40%;\r\n        float: left;\r\n        .user-list-filter {\r\n          height: 2rem;\r\n        }\r\n      }\r\n      .panel-main-header-right {\r\n        float: right;\r\n        .user-list-controls {\r\n          line-height: 2rem;\n          /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/\n          /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/\n          .mat-button-toggle-group {\r\n            height: 2rem;\r\n            margin-right: 20px;\n            /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/\n            mat-button-toggle {\r\n              min-width: 100px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    // table\r\n    .dashboard_grid_item {\r\n      margin-left: 0.5rem;\r\n      height: calc(100% - 9rem);\r\n\r\n      // table head\r\n      .dashboard_grid_header.header-sticky {\r\n        .header_row {\r\n          width: calc(100% - 1rem);\r\n          height: 2.86rem;\r\n\r\n          .cell_row {\r\n            padding: 5px 0;\r\n\r\n            .cell_header {\r\n              background-color: #eceef3;\r\n              font-weight: bolder;\r\n              padding: 0;\r\n            }\r\n\r\n            .user_data.user_level_head {\r\n              min-width: calc(10rem + 30px);\r\n            }\r\n          }\r\n\r\n          #header_title_row {\r\n            padding: 0.5rem 0 0.5rem 0.5rem;\r\n            background-color: #eceef3;\r\n            border-bottom: 1px solid #050505;\r\n          }\r\n        }\r\n        .cell_row {\r\n          .user_data.filter_cell {\r\n            input {\r\n              width: 98%;\r\n              height: 90%;\r\n            }\r\n          }\r\n          .user_data.filter_cell.user_level_filter {\r\n            min-width: calc(10rem + 30px);\r\n          }\r\n        }\r\n      }\r\n\r\n      // table body\r\n      .dashboard_grid_content {\r\n        overflow: auto;\r\n        height: 100%;\r\n        .user_row {\r\n          min-height: 36px;\r\n          .cell_row {\r\n            .user_data {\r\n              .value {\r\n                padding-left: 0.5rem;\r\n                line-height: 36px;\r\n                padding: 0;\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        .no-data-error {\r\n          background: transparent;\r\n          left: -1rem;\r\n          opacity: 1 !important;\r\n          padding: 2rem;\r\n          display: flex;\r\n          flex-flow: column;\r\n          align-items: center;\r\n          width: calc(100% - 4rem);\r\n          height: calc(100% - 10rem);\r\n          position: absolute;\r\n          h1,\r\n          h3 {\r\n            text-align: center;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.user-levels-name {\r\n  grid-area: 'level';\r\n}\r\n\r\n.user-levels-actions {\r\n  grid-area: 'actions';\r\n}\r\n\r\n:host::ng-deep {\n  /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/\n  .mat-button-toggle-label-content {\r\n    line-height: 2rem !important;\r\n  }\r\n\r\n  .cell_row {\r\n    display: grid;\r\n    grid-auto-flow: column;\r\n    grid-template-columns: 25% 25% 25% 15% 80px;\r\n\r\n    .action_button_container {\r\n      align-items: center;\r\n      display: flex;\r\n      gap: 0.25rem;\r\n      height: 2.75rem;\r\n      justify-content: center;\r\n\r\n      .action_button {\r\n        align-items: center;\r\n        background: rgba(0, 0, 0, 0.05);\r\n        border-radius: 0.25rem;\r\n        display: flex;\r\n        height: 2rem;\r\n        justify-content: center;\r\n        transition: filter 0.35s;\r\n        width: 2rem;\r\n        font-size: 14px;\r\n\r\n        &:hover {\r\n          background: rgba(0, 0, 0, 0.1);\r\n        }\r\n\r\n        &.disabled {\r\n          filter: grayscale(1) opacity(0.5);\r\n          pointer-events: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    .user_data {\r\n      // min-height: 36px;\r\n      max-height: 130px;\r\n      overflow: auto;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.processing-fadein {\r\n  animation: fadein 1s;\r\n}\r\n.processing-fadeout {\r\n  animation: fadeout 0.5s;\r\n  display: none !important;\r\n}\r\n\r\n.processing--spinner {\r\n  // animation: fadein 2s;\r\n  -ms-grid-columns: auto 1fr;\r\n  background: whitesmoke;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 1px 20px rgba(0, 0, 0, 0.3);\r\n  display: -ms-grid;\r\n  display: grid;\r\n  font-size: 1rem;\r\n  grid-template-columns: auto 1fr;\r\n  height: 30px;\r\n  left: calc(50% - 100px);\r\n  line-height: 1.8rem;\r\n  padding: 20px;\r\n  position: absolute;\r\n  text-align: center;\r\n  top: calc(50% - 100px);\r\n  user-select: none;\r\n  min-width: 200px;\r\n  z-index: 9999 !important;\r\n}\r\n\r\n\r\n.user-levels-container {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, auto);\r\n  width: fit-content;\r\n  gap: 5px;\r\n\r\n  .pill {\r\n    background-color: rgba(236, 238, 243, 0.35);\r\n    border-radius: 13px;\r\n    border: solid 1px #2b495e33;\r\n    font-size: 0.8rem;\r\n    line-height: 13px;\r\n    padding: 5px 10px;\r\n    user-select: none;\r\n    white-space: nowrap;\r\n    display: flex;\r\n    gap: 5px;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    .left {\r\n      display: flex;\r\n      gap: 5px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
